import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LayoutModule } from '@angular/cdk/layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Material Components
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule} from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker'; 
import { MatNativeDateModule } from '@angular/material/core';

import { getSpanishPaginatorIntl } from './generico/tables/tables-datasource';
import { ModalComponent } from './generico/modal/modal.component';
import { TablesComponent } from './generico/tables/tables.component';

import { AplicacionesComponent } from './aplicaciones/aplicaciones.component';
import { AccionesComponent } from './acciones/acciones.component';
import { CrearComponent } from './aplicaciones/crear/crear.component';
import { PerfilesComponent } from './perfiles/perfiles.component';
import { LoginComponent } from './login/login.component';
import { MenuComponent } from './menu/menu.component';
import { RecuperarPassComponent } from './login/recuperar-pass/recuperar-pass.component';
import { AdministradorComponent } from './administrador/administrador.component';
import { EditarMenuComponent } from './editar-menu/editar-menu.component';
import { TreeAccionMenuComponent } from './tree-accion-menu/tree-accion-menu.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClientesComponent } from './clientes/clientes.component';
import { TableClientesComponent } from './generico/tables/table-clientes/table-clientes.component';
import { CrearClienteComponent } from './clientes/crear-cliente/crear-cliente.component';
import { CrearContratoComponent } from './clientes/crear-contrato/crear-contrato.component';
import { AplicacionContratoComponent } from './aplicaciones/aplicacion-contrato/aplicacion-contrato.component';
import { ProrrogasComponent } from './contrato/prorrogas/prorrogas.component';
import { OtroSiComponent } from './contrato/otro-si/otro-si.component';
import { LogContratosComponent } from './contrato/log-contratos/log-contratos.component';
import { TableAdminComponent } from './generico/tables/table-admin/table-admin.component';
import { UsuarioAdminComponent } from './administrador/usuario-admin/usuario-admin.component';
import { ModuloComponent } from './modulo/modulo.component';
import { TableContratosComponent } from './generico/tables/table-contratos/table-contratos.component';
import { TableProrrogasComponent } from './generico/tables/table-prorrogas/table-prorrogas.component';
import { TableOtroSiComponent } from './generico/tables/table-otro-si/table-otro-si.component';
import { TableAplicacionComponent } from './generico/tables/table-aplicacion/table-aplicacion.component';
import { TablePerfilesComponent } from './generico/tables/table-perfiles/table-perfiles.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptorService } from './generico/servicio/jwt-interceptor.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LogoutComponent } from './logout/logout.component';
import { SpinnerComponent } from './generico/spinner/spinner.component';
import { EditarAccionComponent } from './acciones/editar-accion/editar-accion.component';
import { AccionesMenuPerfilComponent } from './acciones-menu-perfil/acciones-menu-perfil.component';
import { OrdenMenuComponent } from './orden-menu/orden-menu.component';
import { NgxCurrencyModule } from "ngx-currency";


@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    ModalComponent,
    TablesComponent,
    LoginComponent,
    RecuperarPassComponent,
    AplicacionesComponent,
    CrearComponent,
    AccionesComponent,
    PerfilesComponent,
    AdministradorComponent,
    EditarMenuComponent,
    TreeAccionMenuComponent,
    ClientesComponent,
    TableClientesComponent,
    CrearClienteComponent,
    CrearContratoComponent,
    AplicacionContratoComponent,
    ProrrogasComponent,
    OtroSiComponent,
    LogContratosComponent,
    TableAdminComponent,
    UsuarioAdminComponent,
    ModuloComponent,
    TableContratosComponent,
    TableProrrogasComponent,
    TableOtroSiComponent,
    TableAplicacionComponent,
    TablePerfilesComponent,
    DashboardComponent,
    LogoutComponent,
    SpinnerComponent,
    EditarAccionComponent,
    AccionesMenuPerfilComponent,
    OrdenMenuComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatRadioModule,
    MatCardModule,
    ReactiveFormsModule,
    MatIconModule,
    MatDialogModule,
    LayoutModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    MatTreeModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxCurrencyModule
  ],
  providers: [
    { provide: MatPaginatorIntl, useValue: getSpanishPaginatorIntl() },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
